import { mapMaterialTemplateCategoryTypes, MaterialTemplateCategoryType } from "./MaterialTemplateCategoryType";

export interface MaterialTemplateType {
    id: number;
    template_name: string | null;
    template_document: string | null;
    status: 1 | 0;
    categoty_data: MaterialTemplateCategoryType[];
}

// to single object maping
export const mapMaterialTemplateType = (data: any): MaterialTemplateType => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const materialTemplateType: MaterialTemplateType = {
        id: data.id,
        template_name: data.template_name || null,
        template_document: data.template_document || null,
        status: data.status,
        categoty_data: Array.isArray(data.categoty_data) ? mapMaterialTemplateCategoryTypes(data.categoty_data) : [],
    }

    return materialTemplateType;
}

// maping list objects
export const mapMaterialTemplateTypes = (data: any[]): MaterialTemplateType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapMaterialTemplateType);
}